import { StyleSheet } from 'aphrodite';
import { charmGray } from '../../../../web/styles/colors';

export const s = StyleSheet.create({
	accountSwitcherTrigger: {
		fontWeight: 400,
		color: charmGray,
		fontSize: 'inherit',
		fontFamily: 'inherit',
		background: 'none',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
	},
	comboboxContent: {
		width: 360,
	},
});
